var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("ValidationAlert", {
        attrs: { "error-list": _vm.errors.collect("server") },
      }),
      _vm._v(" "),
      _c("fieldset", { staticClass: "form__group" }, [
        _c("legend", [_vm._v("Values")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form__group" },
          [
            _c("FormControlCurrency", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'",
                },
              ],
              attrs: { name: "transaction currency" },
              model: {
                value: _vm.formData.currency,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "currency", $$v)
                },
                expression: "formData.currency",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form__group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.companyRevenue,
                expression: "formData.companyRevenue",
              },
              { name: "validate", rawName: "v-validate" },
            ],
            staticClass: "form__control",
            attrs: {
              id: "revenue",
              name: "companyRevenue",
              placeholder: "Enter the company's revenue...",
              required: "",
            },
            domProps: { value: _vm.formData.companyRevenue },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "companyRevenue", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "form__label", attrs: { for: "revenue" } },
            [_vm._v("Client company revenue (in millions)")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form__validation" }, [
            _vm._v(_vm._s(_vm.errors.first("companyRevenue"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group" }, [
          _c("label", { staticClass: "form__label" }, [
            _vm._v("Projected transaction value (in millions)"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "grid" }, [
            _c("div", { staticClass: "col-6 col-bleed-y" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.projectedValueFrom,
                    expression: "formData.projectedValueFrom",
                  },
                  { name: "validate", rawName: "v-validate" },
                ],
                staticClass: "form__control",
                attrs: {
                  id: "value-from",
                  name: "projectedValueFrom",
                  placeholder: "From...",
                  required: "",
                },
                domProps: { value: _vm.formData.projectedValueFrom },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.formData,
                      "projectedValueFrom",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form__validation" }, [
                _vm._v(_vm._s(_vm.errors.first("projectedValueFrom"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 col-bleed-y" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.projectedValueTo,
                    expression: "formData.projectedValueTo",
                  },
                  { name: "validate", rawName: "v-validate" },
                ],
                staticClass: "form__control",
                attrs: {
                  id: "value-to",
                  name: "projectedValueTo",
                  placeholder: "To...",
                  required: "",
                },
                domProps: { value: _vm.formData.projectedValueTo },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.formData,
                      "projectedValueTo",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form__validation" }, [
                _vm._v(_vm._s(_vm.errors.first("projectedValueTo"))),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group form__group--submit" }, [
          _c(
            "button",
            {
              directives: [
                {
                  name: "wait",
                  rawName: "v-wait:disabled",
                  value: "submit",
                  expression: '"submit"',
                  arg: "disabled",
                },
              ],
              staticClass: "btn",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.back.apply(null, arguments)
                },
              },
            },
            [_vm._v("Back")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "wait",
                  rawName: "v-wait:disabled",
                  value: "submit",
                  expression: '"submit"',
                  arg: "disabled",
                },
              ],
              staticClass: "btn btn--primary",
            },
            [_vm._v("Save & Continue")]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }